import { Observable, BehaviorSubject } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { Injectable } from '@angular/core';
import { io } from 'socket.io-client';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class SocketioService {
  _receiveMessage = new BehaviorSubject<any>(null);
  recvMsg = this._receiveMessage.asObservable();
  socket;
  // conversation_id = this.generateMessageUniqueIdentifier();
  // conversation_id: string = '';
  constructor(
    private apiService: ApiService
  ) { }

  setupSocketConnection(token: string) {
    console.log("connection socket io =================>")
    this.socket = io(environment.base_url,{
      auth: { token },
    });
    this.socket.emit('my message', 'Hello there from Angular.');
    this.socket.emit('private message', 'private message from Angular.');

    this.socket.on('my broadcast', res => {
      console.log("server =========>", res);
    })

  }

  sendMessage(message, receiver_id, conversation_id){
    let data = {
      messageBody: message,
      conversation_id: conversation_id,
      receiver_id: receiver_id
    }
    console.log("data", data);
    this.socket.emit('message', data);

    this.socket.on(conversation_id, res => {
      this.saveMessage(res);
      this._receiveMessage.next(res);
      console.log("message received from server =========>", res);
    })

    this.socket.on('new message', res => {
      console.log("new message from server user =======>", res);
    });

    // this.socket.on('notify', function (data) {
    //   this._receiveMessage.next(data);
    //   console.log('notify');
    //   console.log(data);

    //   console.log('notify');
    // });
  }

  disconnect() {
    if (this.socket) {
      console.log("disconnecting socket io")
      this.socket.disconnect();
    }
  }

  generateMessageUniqueIdentifier(){
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for( var i=0; i < 6; i++ )
         text += possible.charAt(Math.floor(Math.random() * possible.length));
     return text;
  }

  saveMessage(data){
    console.log("function called");
    let message = {
      'message_subject': 'private Message',
      'message_body': data.messageBody,
      'receiver_id': data.receiver_id,
      'conversation_id': data.conversation_id,
    };

    this.apiService.post('chats/messages', message).subscribe(
      (res: any[]) => {
      console.log("message saved successfully");
    });
  }

}
